import GraphQLJSON from 'graphql-type-json'
import { Field, InputType, ID } from 'type-graphql'
import { ActionArgs } from '../../action/ActionArgs'
import type { IAction } from '../../action/IAction'
import type { Product } from '../Product'
import type { ImportExportProductSpec } from './ImportProductWithSpecArgs'

@InputType()
export class ProductUpdateMetadataServiceArgs extends ActionArgs {
  @Field(() => GraphQLJSON)
  metadata: ImportExportProductSpec[]

  @Field(() => ID)
  productId: string

  @Field(() => String)
  settingName: string
}

export interface IProductUpdateMetadataService extends IAction<Product, ProductUpdateMetadataServiceArgs> {}
